import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import {
  getClassifiersDisseminationLevelList,
  getClassifiersDisseminationLevelListData,
  getClassifiersDisseminationLevelDelete,
} from '../../reducers/classifiersReducer';
import {
  showDisseminationLevelEditModal,
  hideDisseminationLevelEditModal,
  getDisseminationLevelEditModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Spin, Modal, Button } from 'antd';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { DisseminationLevelTable, TableActions } from '../../components';
import { DisseminationLevelEdit as DisseminationLevelEditForm } from '../../forms';
import { goToClassifiers } from '../../utils/gotoLink';

const DisseminationLevelList = ({
  t,
  loading,
  fetchClassifier,
  deleteClassifier,
  classifierData,
  modalVisible,
  hideModal,
  showModal,
}) => {
  const selectedCodeRef = useRef(null);

  useEffect(() => {
    fetchClassifier();
  }, [fetchClassifier]);

  const handleShowModal = (code = null) => {
    selectedCodeRef.current = code;
    showModal();
  };

  return (
    <Spin spinning={loading}>
      <h1>{t('disseminationLevel')}</h1>
      {classifierData && (
        <DisseminationLevelTable
          t={t}
          dataSource={classifierData.toJS()}
          deleteClassifier={deleteClassifier}
          showModal={handleShowModal}
        />
      )}
      {modalVisible && (
        <Modal
          title={t('disseminationLevel')}
          open
          footer={null}
          onCancel={hideModal}
          width={640}
        >
          <DisseminationLevelEditForm
            onCancel={hideModal}
            onComplete={hideModal}
            operatorCode={selectedCodeRef.current}
            t={t}
          />
        </Modal>
      )}
      <TableActions>
        <Button onClick={goToClassifiers}>{t('buttonBack')}</Button>
        <Button
          type="primary"
          onClick={() => handleShowModal(null)}
          className="global-margin-left-10"
        >
          {t('buttonValueAdd')}
        </Button>
      </TableActions>
    </Spin>
  );
};

DisseminationLevelList.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchClassifier: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  classifierData: PropTypesImmutable.list,
  modalVisible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

const getIsLoading = getLoadingSelector(
  getClassifiersDisseminationLevelList,
  getClassifiersDisseminationLevelDelete
);

const mapStateToProps = (state) => ({
  loading: getIsLoading(state),
  classifierData: getClassifiersDisseminationLevelListData(state),
  modalVisible: getDisseminationLevelEditModal(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchClassifier: () => {
    dispatch(actions.fetchClassifierDisseminationLevelList());
  },
  deleteClassifier: async (code) => {
    await dispatch(actions.deleteClassifierDisseminationLevel(code));
    dispatch(actions.fetchClassifierDisseminationLevelList());
  },
  showModal: () => {
    dispatch(showDisseminationLevelEditModal());
  },
  hideModal: () => {
    dispatch(hideDisseminationLevelEditModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisseminationLevelList);
